import React, { useState } from 'react';
import { AppData } from '../data/apps';

interface TaskbarIconProps {
  app: AppData;
  onClick?: () => void;
}

/**
 * Single pinned icon in the taskbar center with a hover tooltip.
 * @param {TaskbarIconProps} props
 * @param {AppData} props.app - App metadata (name, icon, isCustomIcon).
 * @param {function} [props.onClick] - Click handler for opening/toggling the app.
 */
const TaskbarIcon: React.FC<TaskbarIconProps> = ({ app, onClick }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div 
      className="taskbar-icon"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
      onClick={onClick}
    >
      <div className="taskbar-app-icon">
        {app.isCustomIcon ? (
          <img 
            src={app.icon} 
            alt={app.name}
            width="20"
            height="20"
            style={{ 
              display: 'block',
              filter: 'drop-shadow(0 1px 2px rgba(0, 0, 0, 0.3))'
            }}
            onError={(e) => {
              // Fallback to placeholder if image fails
              const target = e.target as HTMLImageElement;
              target.style.display = 'none';
              const parent = target.parentElement;
              if (parent) {
                parent.innerHTML = '🔗';
                parent.style.fontSize = '20px';
              }
            }}
          />
        ) : (
          app.icon
        )}
      </div>
      
      {showTooltip && (
        <div className="taskbar-tooltip">
          {app.name}
        </div>
      )}
    </div>
  );
};

export default TaskbarIcon;